import Controller from '@ember/controller';
import { get } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type UploadContactsService from 'donor-elf-web/services/upload-contacts';

export default class UploadMapController extends Controller {
  @service declare router: RouterService;
  @service declare uploadContacts: UploadContactsService;

  @tracked errorMessage?: string = undefined;

  get displayNameIsMapped() {
    const displayNameMapping = this.uploadContacts.activeColumnMappings.find(
      (mapping) => {
        return get(mapping, 'property') === 'name';
      },
    );

    return displayNameMapping != null;
  }

  reset() {
    this.errorMessage = undefined;
  }

  next = () => {
    if (!this.displayNameIsMapped) {
      this.errorMessage =
        "You have to map the 'Display Name' property to a column";
      return;
    }

    this.router.transitionTo('funds.fund.contacts.upload.verify');
  };
}
